<div class="module-wrapper content-wrapper" *ngIf="roleSer.accessData && (roleSer.accessData.viewAllowed || roleSer.accessData.insertAllowed)">
  <mat-card>
    <mat-card-content>
      <div class=" head-container">
        <h1>{{'items.heading' | translate}}</h1>
        <!-- <div (mouseover)="onTrainingIcon(videoAssetGroups.ItemManagement)">
          <img class="trainingIcon" src="../../../assets/favicon/video.png">
        </div>
        <div class="popupHover">
          <ng-container *ngIf="isHidden">
            <div class="hideshow">
              <a *ngFor="let links of videoLinks" (click)="open_in_new_window('location=1,status=1,toolbar=1,resizeable=1,width=350,height=300', links.assetUrl);">{{links.assetShortName}} <br></a>
            </div>
          </ng-container>
        </div> -->
      </div>
      <div class="itemBtn">
        <span class="spacer"></span>
        <div>
          <div class="btn-wrapper">
            <button mat-flat-button color="" [disabled]="roleSer.accessData?!roleSer.accessData.insertAllowed :true" class="btn-warn"
              aria-label="Add New Item" (click)="openNewItemDialog()">
              + {{'items.btnNewItem' | translate}}</button>
            <button mat-flat-button color="" [disabled]="roleSer.accessData?!roleSer.accessData.insertAllowed:true" class="btn-flat"
              aria-label="Add Multiple Items" (click)="addMultipleItems()"><span>+ {{'items.btnMultipleItem' | translate}}</span></button>
          </div>
        </div>
      </div>

      <div class="input-container">
        <div class="input-fields-wrapper">
          <div class="input-wrapper invalid">
            <input type="text" placeholder="{{'items.inputName' | translate}}" [(ngModel)]="itemName" class="form-control ng-untouched ng-pristine ng-valid"
            ng-reflect-model="" filterValidator="Name">
          </div>
          <div class="input-wrapper invalid">
            <input type="text" placeholder="{{'items.inputDesc' | translate}}" [(ngModel)]="itemDescription" class="form-control ng-untouched ng-pristine ng-valid"
            ng-reflect-model="" filterValidator="Description">
          </div>
          <div class="input-wrapper invalid">
            <input type="text" placeholder="{{'items.inputTag' | translate}}" [(ngModel)]="tag" class="form-control ng-untouched ng-pristine ng-valid" ng-reflect-model="" filterValidator="Name">
          </div>
          <div class="input-wrapper">
            <select aria-placeholder="Status" [(ngModel)]="itemStatus" class="form-control ng-untouched ng-pristine ng-valid" ng-reflect-model="">
              <option value="0">{{'items.labelStatus' | translate}}</option>
              <option *ngFor="let statusList of statusArray" value="{{ statusList.itemStatusId }}">
                {{ statusList.itemStatus }}
              </option>
            </select>
          </div>

          <div class="btn-wrapper">
            <button mat-flat-button color="" class="btn-primary" (click)="itemFilter()" aria-label="Search"
              [disabled]="(roleSer.accessData? !roleSer.accessData.viewAllowed :true)">{{'items.btnSearch' | translate}}</button>
            <button mat-flat-button color="" class="btn-flat" (click)="resetFilter()" aria-label="Reset"
              [disabled]="(roleSer.accessData? !roleSer.accessData.viewAllowed :true)">{{'items.btnReset' | translate}}</button>
          </div>
        </div>
      </div>

      <div *ngIf="isNoItems" class="data-not-found-container table-container">
        <span *ngIf="!isSearched">{{'items.errorMsg' | translate}}</span>
        <span *ngIf="isSearched">{{'items.errorMsg1' | translate}}</span>
      </div>
      <div class="d-none" [class.d-block]="items" *ngIf="!isNoItems">
        <div class="table-container">
          <table mat-table [dataSource]="items" matSort class="mat-elevation-z8">
            <ng-container matColumnDef="itemBankName">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'items.column1' | translate}}</th>
              <td mat-cell *matCellDef="let row" (click)="navigateToItemDetails(row.itemuuid,row.itemBankId, row)">
                <ng-container *ngIf="row?.itemBankName?.length > 40 then sliceTitle else noSliceTitle">
                </ng-container>

                <ng-template #sliceTitle>
                  <div class="text-bold" matTooltipClass="my-custom-tooltip" matTooltip="{{row?.itemBankName}}" matTooltipPosition="above">
                    {{row?.itemBankName | slice: 0:40}}...</div>
                </ng-template>
                <ng-template #noSliceTitle>
                  <div class="text-bold">{{row?.itemBankName }}</div>
                </ng-template>

                <ng-container *ngIf="row?.itemDescription?.length > 40 then sliceDescription else noSliceDescription">
                </ng-container>
                <ng-template #sliceDescription>
                  <div matTooltipClass="my-custom-tooltip" matTooltip="{{row?.itemDescription}}" matTooltipPosition="above" class="description-text">
                    {{row?.itemDescription | slice: 0:40}}...</div>
                </ng-template>
                <ng-template #noSliceDescription>
                  <div class="description-text">{{row?.itemDescription }}</div>
                </ng-template>
              </td>
            </ng-container>

            <ng-container matColumnDef="questionTypes">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'items.column2' | translate}}</th>
              <td mat-cell *matCellDef="let row" (click)="navigateToItemDetails(row.itemuuid,row.itemBankId, row)">{{row.questionTypes}}
              </td>
            </ng-container>

            <ng-container matColumnDef="scoringType">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'items.column6' | translate}}</th>
              <!-- <td mat-cell *matCellDef="let row">
                {{row.scoringTypeId == 1 ? ScoringTypeNameEnum.OnQuestion : row.scoringTypeId == 3 ? ScoringTypeNameEnum.On180360Degree : ScoringTypeNameEnum.OnOption}}</td> -->
                <td mat-cell *matCellDef="let row"  (click)="navigateToItemDetails(row.itemuuid,row.itemBankId, row)">
                  {{row.scoringTypeId == 1 ? ('items.questionScoring' | translate) : row.scoringTypeId == 3 ? ('items.DICSStyle' | translate) :
                  ('items.optionScoring' | translate)}}</td>
            </ng-container>

            <ng-container matColumnDef="itemStatus">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'items.column3' | translate}}</th>
              <td mat-cell *matCellDef="let row"  (click)="navigateToItemDetails(row.itemuuid,row.itemBankId, row)">
                <span *ngIf="row?.statusName === 'Published'" class="fa fas fa-circle publish" matTooltip="{{'items.toolTip.publish' | translate}}" matTooltipPosition="above">
                </span>
                <span *ngIf="row?.statusName === 'Unpublished'" class="glyphicon glyphicon-adjust unpublish" matTooltip="{{'items.toolTip.unPublish' | translate}}"
                  matTooltipPosition="above"></span>
              </td>
            </ng-container>

            <ng-container matColumnDef="updated">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'items.column4' | translate}}</th>
              <td mat-cell *matCellDef="let row"  (click)="navigateToItemDetails(row.itemuuid,row.itemBankId, row)">
                <div class="text-bold"> {{row?.modifiedUserName }} </div> <div> {{row.updated | dateAgo}} </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="tags">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'items.column5' | translate}}</th>
              <td mat-cell *matCellDef="let row"  (click)="navigateToItemDetails(row.itemuuid,row.itemBankId, row)">
                <ng-container *ngIf="row.tagdescriptionString?.length > 40; then sliceTitle; else noSlice ">
                </ng-container>

                <ng-template #sliceTitle>
                  <div matTooltipClass="my-custom-tooltip" matTooltip="{{row?.tagdescription}}" matTooltipPosition="above" class="description-text">
                    <span [innerHtml]="(row.tagdescription | boldTag)"></span>
                  </div>
                </ng-template>
                <ng-template #noSlice>
                  <span [innerHtml]="(row.tagdescription | boldTag)"></span>
                </ng-template>
              </td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" class="action">{{'items.column7' | translate}}</th>
              <td mat-cell *matCellDef="let row" class="action">

                <button mat-icon-button (click)="(currentUserData.userRolesCollections[0].rolesAssigned != 'Account Admin' || row.statusId === 1) ? '' : deleteItem(row)"
                [ngClass]="{'disableIcon': currentUserData.userRolesCollections[0].rolesAssigned != 'Account Admin' || row.statusId === 1}"
                matTooltip="{{'itemDetails.TabQuestions.itemTable.delete' | translate}}">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr class="pointer" mat-row *matRowDef="let row; columns: displayedColumns;">
            </tr>
          </table>
        </div>
        <div class="item-paginator">
          <mat-paginator #paginator [pageSizeOptions]="[10, 50, 100]" showFirstLastButtons></mat-paginator>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
